import { containsHtml } from './url';

const lineBreakTagPattern = /<br\s*\/?>/giu;
const blockEndTagPattern = /<\/(p|div|li|h[1-6]|tr)>/giu;
const trailingLineBreaksPattern = /\n+$/u;

/**
 * Converts legacy HTML (e.g. an old company note) to plain text, keeping line breaks.
 * Text without markup is returned unchanged.
 *
 * @param value - Text that may contain HTML.
 * @returns The plain text, or the input when it holds no markup.
 */
const htmlToPlainText = (value: string | null | undefined): string | null => {
  if (!value || !containsHtml(value)) {
    return value ?? null;
  }

  const withLineBreaks = value.replace(lineBreakTagPattern, '\n').replace(blockEndTagPattern, '\n');
  const document = new DOMParser().parseFromString(withLineBreaks, 'text/html');

  return (document.body.textContent ?? '').replace(trailingLineBreaksPattern, '');
};

export default htmlToPlainText;
